import { Button, Container, Grid, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { freelancerApi } from "../../API/Api";
import FreelancerItem from "./FreelancerItem";
import { motion } from "framer-motion";
import { tokens } from "../../../store/tokens";

const sectionTitleSx = {
  fontFamily: tokens.font.heading,
  fontWeight: tokens.type.h2.fontWeight,
  letterSpacing: tokens.type.h2.letterSpacing,
  fontSize: { xs: "1.7rem", md: tokens.type.h2.fontSize },
  lineHeight: tokens.type.h2.lineHeight,
  color: tokens.textOn.light.primary,
};
const sectionSubtitleSx = {
  fontFamily: tokens.font.body,
  fontSize: tokens.type.body1.fontSize,
  lineHeight: tokens.type.body1.lineHeight,
  color: tokens.textOn.light.secondary,
  maxWidth: 560,
};
const primaryButtonSx = {
  borderRadius: `${tokens.button.radius}px`,
  height: tokens.button.height.lg,
  px: `${tokens.button.paddingX.lg}px`,
  fontFamily: tokens.font.body,
  fontWeight: tokens.type.button.fontWeight,
  fontSize: tokens.button.fontSize.lg,
  textTransform: tokens.type.button.textTransform,
  bgcolor: tokens.bg.brand,
  color: tokens.color.white,
  boxShadow: "none",
  transition: "background-color 0.2s ease",
  "&:hover": { bgcolor: tokens.bg.brandDark },
};

const Freelancer = () => {
  const navigate = useNavigate();
  const [freelancerData, setFreelancerData] = useState([]);

  useEffect(() => {
    fetch(freelancerApi)
      .then((res) => res.json())
      .then((result) => {
        setFreelancerData(result.slice(0, 4));
      })
      .catch((error) => console.log("freelancerData Error => ", error));
  }, []);

  return (
    <Box mt={{ xs: 6, md: 8 }}>
      <Stack
        component={motion.div}
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.5 }}
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        spacing={1.25}
        sx={{ px: 2, mb: { xs: 3, md: 4 } }}
      >
        <Typography component="h2" sx={sectionTitleSx}>
          Verified professionals
        </Typography>
        <Typography sx={sectionSubtitleSx}>
          Get connected with verified, experienced professionals to get your
          job done with quality.
        </Typography>
      </Stack>

      <Container maxWidth="lg">
        <Grid container spacing={2}>
          {freelancerData?.map((element, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={element.refer_id}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.35, delay: index * 0.06 }}
                whileHover={{ y: -4 }}
              >
                <FreelancerItem freelancerData={element} />
              </motion.div>
            </Grid>
          ))}
        </Grid>

        <Stack direction="row" justifyContent="center" alignItems="center" mt={{ xs: 3, md: 4 }} mb={4}>
          <Button
            component={motion.button}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.97 }}
            variant="contained"
            onClick={() => navigate("/expertlist")}
            sx={primaryButtonSx}
          >
            Load more
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};

export default Freelancer;